import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import {Breadcrumb, Icon, Spin, Input, Button, Popover, Avatar, DatePicker, Badge, Collapse, Pagination} from 'antd';
import { GetEditionParams } from '../../APIModels/ApiParamsIndex';
import EditionService from '../../Services/editionService';
import { FMKEditionsTable } from './FMKEditionsTable';
import FileService from '../../Services/fileService';
import { downloadFileBlob } from '../../util/UtilFunction';
import moment from 'moment';
import {CardEdition} from "./CardEdition";
import {PageSizeOptionsString} from "../../APIModels/BaseParams";

export class FMKEditions extends React.Component
{
    constructor(props) {
        super(props)

        document.title = "Polar - Archive"
        this.props.showUserBadge(false);
        this.state = {
            user: this.props.token,
            hasFiltersOn: false,
            editions: [],
            fetchFinish: false,
            param: new GetEditionParams(),
            paramResponse: null,
            modalOpen: false,
            modalTitle: '',
            modalId: '',
        }

        this.editionService = new EditionService(this.props.token);
        this.fileService = new FileService(this.props.token);

        this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
        this.handleDateTimeFromChange = this.handleDateTimeFromChange.bind(this);
        this.handleDateTimeToChange = this.handleDateTimeToChange.bind(this);
        this.handleFilters = this.handleFilters.bind(this);
        this.handleFiltersKeyPress = this.handleFiltersKeyPress.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.deleteEdition = this.deleteEdition.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.setModal = this.setModal.bind(this);
        this.setPagination = this.setPagination.bind(this);
        this.showSizeChange = this.showSizeChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        this.props.loader(true)
        this.editionService.getEditionList(this.state.param)
            .then((response) => {
                this.props.loader(false)
                this.setState({ editions: response.data.data, paramResponse: response.data.params, fetchFinish: true })
            })
            .catch((err) => this.props.loader(false) );
    }

    deleteEdition(id) {
        this.editionService.deleteEdition(id)
            .then((response) => this.fetchData() )
            .catch((err) => console.log(err))
    }

    handleInputFilterChange({ target }) {
        const value = target.value;
        const name = target.name;
        this.setState(prevState => ({
            param: {
                ...prevState.param,
                [name]: value
            }
        }))
    }

    handleDateTimeFromChange(value) {
        let date = moment(value).utc().startOf('day');

        this.setState(prevState => ({
            param: {
                ...prevState.param,
                publicationDateFrom: date
            }
        }))
    };

    handleDateTimeToChange(value) {
        let date = moment(value).utc().endOf('day');
        this.setState(prevState => ({
            param: {
                ...prevState.param,
                publicationDateTo: date
            }
        }))
    };

    handleFiltersKeyPress(e) {
        if (e.key === 'Enter') {
            this.handleFilters();
        }
    }

    handleFilters() {
        this.setState({ hasFiltersOn: true })
        this.fetchData()
    }

    clearFilters() {
        let paramEmpty = new GetEditionParams()
        this.setState({ param: paramEmpty, hasFiltersOn: false }, (() => this.fetchData()))
    }

    downloadFile(id, name, type) {
        this.fileService.downloadFile(id)
            .then(resp => {
                downloadFileBlob(resp.data, name, type)
            })
    }

    setModal(value, title, id) {
        this.setState({ modalOpen: value, modalTitle: title, modalId: id })
    }

    setPagination(size, page) {
        let param = new GetEditionParams(this.state.param)
        param.pageSize = size
        param.page = page
        this.setState({ param: param }, (() => this.fetchData()))
    }

    showSizeChange(current, size) {
        this.setPagination(size, current)
    }

    pageChange(page, size) {
        this.setPagination(size, page)
    }

    render() {

        let filter =
            <div className="p-4" onKeyPress={this.handleFiltersKeyPress}>
                <div className="filterGroup">
                    <Row>
                        <Col sm="5">
                            <p className="mb-2 font-weight-bold">Magazine</p>
                            <Input autoComplete="new-password" type="text" name="magazineName"
                                   value={this.state.param.magazineName}
                                   style={{display: 'block', margin: '0px 0px 10px auto'}}
                                   placeholder="Start typing to filter"
                                   allowClear={true} onChange={this.handleInputFilterChange}/>
                        </Col>
                        <Col sm="2">
                            <p className="mb-2 font-weight-bold">Number editions</p>
                            <Input autoComplete="new-password" type="number" name="number"
                                   value={this.state.param.number}
                                   style={{display: 'block', margin: '0px 0px 0px auto'}}
                                   placeholder="Start typing to filter"
                                   allowClear={true} onChange={this.handleInputFilterChange}/>
                        </Col>
                        <Col sm="5">
                            <p className="mb-2 font-weight-bold">Description editions</p>
                            <Input autoComplete="new-password" type="text" name="description"
                                   value={this.state.param.description}
                                   style={{display: 'block', margin: '0px 0px 0px auto'}}
                                   placeholder="Start typing to filter" allowClear={true}
                                   onChange={this.handleInputFilterChange}/>
                        </Col>
                        <Col sm="5">
                            <Row>
                                <Col sm="6">
                                    <p className="mb-2 mt-2 font-weight-bold">Competence date from</p>
                                    <DatePicker format="DD/MM/YYYY" name="publicationDateFrom"
                                                value={this.state.param.publicationDateFrom} className="startDatePicker"
                                                placeholder="DD/MM/YYYY" onChange={this.handleDateTimeFromChange}/>
                                </Col>
                                <Col sm="6">
                                    <p className="mb-2 mt-2 font-weight-bold">Competence date to</p>
                                    <DatePicker format="DD/MM/YYYY" name="publicationDateTo"
                                                value={this.state.param.publicationDateTo} className="startDatePicker"
                                                placeholder="DD/MM/YYYY" onChange={this.handleDateTimeToChange}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Row className="justify-content-center mt-4">
                    <Button className="fmk_button" onClick={this.handleFilters} style={{marginLeft: '16px', marginBottom: '10px'}}>Apply</Button>
                    <Button className="fmk_button secondary" onClick={this.clearFilters} style={{ marginLeft: '16px', marginBottom: '10px' }}>Clear Filters</Button>
                </Row>
            </div>

        let breadcrumb = 
            <Col sm="12" style={{ display: 'inline-flex', height: '0', justifyContent: "end" }}>
                <Breadcrumb className="bread" style={{left: 24}}>
                    <Breadcrumb.Item>
                        <strong className="h5 font-weight-bold" style={{color: 'black'}}>All editons</strong>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="plusButtonCat">
                    <a className="button mr-3" href="/archive/edition/create">
                        <Icon type="plus" /> New Edition
                    </a>
                    <Badge>
                        <Popover placement="bottomRight" content={this.props.usercontent} trigger="click">
                            <div style={{cursor: 'pointer'}}>
                                <Avatar style={{backgroundColor: this.props.avatarColor, marginLeft: '5px'}} icon="user"/>
                            </div>
                        </Popover>
                    </Badge>
                </div>
            </Col>

        let panelTitle = <strong>
            <Icon type="filter" />
            <span className="ml-2">Advanced filters</span>
        </strong>

        const paramResponse = this.state.paramResponse;

        return (
            <Container fluid={true}>
                <Row style={{minHeight: 'unset'}}>
                    {/*BREADCRUMB*/}
                    {breadcrumb}
                    <Col sm="12">
                        <Collapse className="mt-4">
                            <Collapse.Panel className="fmk-collapse" header={panelTitle} key="1">
                                {filter}
                            </Collapse.Panel>
                        </Collapse>
                    </Col>
                    <Col sm="12" className="mt-4">
                        {(this.state.paramResponse && this.state.paramResponse.totalItems !== this.state.paramResponse.totalItemsWithoutFilters) && (
                            <Col sm="12" className="mb-4 p-0">
                                <Button onClick={this.clearFilters} className="mr-3 fmk_button accent" >Clear filters</Button>
                                <span className="float-right mt-2">
                                    <strong>Results: </strong>
                                    <span>{this.state.paramResponse.totalItems}/{this.state.paramResponse.totalItemsWithoutFilters}</span>
                               </span>
                            </Col>
                        )}
                        {/*TABELLA*/}
                        <Row className="mb-4">
                            {this.state.editions.map(edition => {
                                return (
                                    <Col className="mb-4" style={{flex: "1 0 20%", maxWidth: '20%'}} key={edition.id}>
                                        <CardEdition edition={edition}/>
                                    </Col>
                                )
                            })
                            }

                            {(paramResponse) &&  (
                               <Col sm="12">
                                   <Pagination className="FMKPagination mb-4 d-block"
                                               showSizeChanger
                                               hideOnSinglePage
                                               pageSizeOptions={PageSizeOptionsString}
                                               onChange={this.pageChange}
                                               onShowSizeChange={this.showSizeChange}
                                               size="small"
                                               total={paramResponse.totalItems}>
                                   </Pagination>
                               </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

}



// WEBPACK FOOTER //
// ./src/FileMaker/Editions/FMKEditions.js